import React, { useId } from 'react';

/** Clean login backdrop — soft gradient + minimal support-desk accents (no busy UI mockups). */
const LoginAppBg = ({ className = 'scene-app-svg' }) => {
  const id = useId().replace(/:/g, '');

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 900"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden
      focusable="false"
    >
      <defs>
        <linearGradient id={`${id}-sky`} x1="0" y1="0" x2="0.4" y2="1">
          <stop offset="0%" stopColor="#dceefb" />
          <stop offset="42%" stopColor="#b8d4f0" />
          <stop offset="100%" stopColor="#8ec0ea" />
        </linearGradient>
        <radialGradient id={`${id}-glow-l`} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.55" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
        </radialGradient>
        <radialGradient id={`${id}-glow-r`} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#2563eb" stopOpacity="0.14" />
          <stop offset="100%" stopColor="#2563eb" stopOpacity="0" />
        </radialGradient>
      </defs>

      <rect width="1440" height="900" fill={`url(#${id}-sky)`} />
      <ellipse cx="320" cy="260" rx="340" ry="280" fill={`url(#${id}-glow-l)`} />
      <ellipse cx="1120" cy="620" rx="380" ry="300" fill={`url(#${id}-glow-r)`} />
      <ellipse cx="1180" cy="180" rx="200" ry="160" fill="#fff" opacity="0.22" />

      {/* Soft horizon */}
      <path
        fill="#7eb3e8"
        opacity="0.35"
        d="M0 640 Q480 560 900 600 T1440 580 V900 H0Z"
      />
      <path
        fill="#5a9fd0"
        opacity="0.28"
        d="M0 720 Q520 660 960 700 T1440 680 V900 H0Z"
      />

      {/* Minimal laptop — left, out of the way */}
      <g transform="translate(120, 420)" opacity="0.14" stroke="#0c2848" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <rect x="0" y="0" width="200" height="130" rx="12" />
        <path d="M-16 130h232l-20 28H4Z" />
        <path d="M50 52h100M50 72h72M50 92h88" strokeWidth="2" opacity="0.7" />
      </g>

      {/* Minimal ticket — right */}
      <g transform="translate(1080, 200)" opacity="0.12" stroke="#0c2848" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <path d="M0 20h120l-14 28 14 28H0V20Z" />
        <path d="M36 52h48M36 72h36" strokeWidth="2" />
      </g>

      {/* Headphones accent — subtle */}
      <g transform="translate(980, 520)" opacity="0.1" stroke="#123a66" strokeWidth="2.5" fill="none">
        <path d="M20 40c0-40 80-40 80 0v48" />
        <rect x="4" y="44" width="28" height="44" rx="10" />
        <rect x="88" y="44" width="28" height="44" rx="10" />
      </g>

      {/* Tiny floating dots — texture only */}
      <g fill="#0c2848" opacity="0.06">
        <circle cx="200" cy="160" r="4" />
        <circle cx="240" cy="200" r="3" />
        <circle cx="1240" cy="340" r="4" />
        <circle cx="1280" cy="380" r="3" />
        <circle cx="680" cy="120" r="3" />
      </g>
    </svg>
  );
};

export default LoginAppBg;
